module.exports = __webpack_public_path__ + "media/images/athletes/2367-214f3d202e09bde6a12b7c18d47a3512.png";